import { AppContextUrls, IApplicationContext, IHttpProvider } from '@thedevshop/core';
import { FetchHttpProvider } from './FetchHttpProvider';

export const endpoint ='https://ps-bp-admin.thedevshoptest.app/api';

export function getUrls(root?: string): AppContextUrls {
    // root = root ?? '/api';
    root = endpoint;
    return {
        root,
        auth: {
            token: `${root}/token`,
            currentUser: `${root}/current-user`,
            register: `${root}/register`,
            updatePassword: `${root}/update-password`,
        },
        func: (className: string, functionName: string) => `${root}/${className}/${functionName}`,
        instance: (className: string, id?: string) => (id ? `${root}/instance/${className}/${id}` : `${root}/instance/${className}`),
        instanceAcl: (className: string, id: string) => `${root}/instance/${className}/${id}`,
        instanceValidate: (className: string) => `${root}/instance/validate/${className}`,
        instanceFactory: (className: string) => `${root}/instance/validate/${className}`,
        instanceSequence: (className: string) => `${root}/instance/sequence/${className}`,
        lockerUpload: () => `${root}/locker/upload`,
        locker: (fileId: string) => `${root}/locker/${fileId}`,
        message: `${root}/message`,
        translations: `${root}/translations/all`,
    };
}

export class GenericApplicationContext implements IApplicationContext {
    token: string =
      'AhfCl8KDw6DDqRxOwpsnBDpdV8ObIw==w5jCimjCkAXDlhpCwqnDi8ORw7zClghqwoE='; // localStorage.getItem('token')!;
    host: string = '';
    organization: string = ''; //localStorage.getItem('organization')!;
    user: any;
    httpProvider: IHttpProvider = new FetchHttpProvider();
    urls: AppContextUrls = getUrls(process.env.API_URL);
    settings?: any;
  }
  

// --------------------
// The example below is how you could type all your possible errors
// for handling them individually in your front-end. In Conduit's case,
// we're only rendering the errors with their corresponding key, so this is
// not necessary
// --------------------
// export type TEmailPswdErrors = 'is invalid';
// export type TUsernameErrors = 'has already been taken';

export interface IAPIErrors {
    // 'email or password': Array<TEmailPswdErrors>;
    // username: Array<TUsernameErrors>;
    [key: string]: string[];
}

export interface IBaseAPIReq {
    errors?: IAPIErrors;
}

export interface IStandardReq {
    path: string;
    method: 'GET' | 'PUT' | 'POST' | 'DELETE';
    body?: string;
    token?: string;
}

export const standardReq = async ({ path, method, body, token }: IStandardReq) => {
    const reqPath = `${endpoint}/${path}`;
    let headers: { [key: string]: string } = {
        'content-type': 'application/json',
    };

    token = token ? token : localStorage.getItem('token');

    if (token) {
        headers = { ...headers, authorization: `Bearer ${token}` };
    }
    try {
        const req = await fetch(reqPath, {
            credentials: 'omit',
            headers,
            method,
            body,
            mode: 'cors',
        });
        const data = await req.json();
        return data;
    } catch (errors) {
        console.error(errors);
        return { errors };
    }
};

export const getRandomNumber = () => {
    return Math.floor(Math.random() * 10000000);
}

export const doArraysOverlap = (array1: Array<any>, array2: Array<any>) => {
    for (const element of array1) {
        if (array2.includes(element)) {
            return true;
        }
    }
    return false;
}
